export const ASURIONUI_VIEWPORTS = {
  aui_sm: {
    name: 'AsurionUI SM',
    styles: {
      height: '100%',
      width: '375px'
    },
    type: 'mobile'
  },
  aui_md: {
    name: 'AsurionUI MD',
    styles: {
      height: '100%',
      width: '768px'
    },
    type: 'mobile'
  },
  aui_md2: {
    name: 'AsurionUI MD2',
    styles: {
      height: '100%',
      width: '1024px'
    },
    type: 'mobile'
  },
  aui_lg: {
    name: 'AsurionUI LG',
    styles: {
      height: '100%',
      width: '1280px'
    },
    type: 'mobile'
  },
  aui_xl: {
    name: 'AsurionUI XL',
    styles: {
      height: '100%',
      width: '1440px'
    },
    type: 'mobile'
  },
  aui_xxl: {
    name: 'AsurionUI XXL',
    styles: {
      height: '100%',
      width: '1920px'
    },
    type: 'mobile'
  }
};